import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

export default function CircularLoader({ classes, size }) {
  return <CircularProgress className={classes} size={size} />;
}
